module.exports = __webpack_public_path__ + "static/media/Zamora-Drywall-Inc (3).cccc9202.jpg";